import { useEffect, useLayoutEffect, useState} from 'react';
import {getAccountName} from './helpers/racefunctions';
import '../yamscss.css'
const getcollection  = require('./json/collections.json');



export function RaceViewer ({raceinfo}) {

    const [distance, setDistance] = useState({ d: [] });
    const [img, setImg] = useState({ url: [""] });
    const [names, setNames] = useState({ n: [""] });
    const [position, setPosition] = useState({ pos: [] });
    const [nums, setNums] = useState({ num: [] });
    const [aWinner, setAWinner] = useState("");
    const [bWinner, setBWinner] = useState(0);
    const [roles, setRoles] = useState([""]);
    const [showNext, setShowNext] = useState(false);
    const [currraceinfo, setCurrraceInfo] = useState({});
    const [prevRace, setPrevRace] = useState(0);
    const [nextRace, setNextRace] = useState(0);
    const racenum = raceinfo;
    const [raceToRun, setRaceToRun] = useState(0);
    const [raceToDisp, setRaceToDisp] = useState(1);
    const [winnersToShow, setWinners] = useState([]);
    const [scoreBoardHead, setScoreBoardHead] = useState([]);


    useEffect(() => {
        getRacers(raceToRun);
    }, [raceToRun]);

    useEffect(() => {
        getRaceInfo(racenum);
        }, []);


    const setRToR = (racetorun) => {
        const racepos = currraceinfo.racenums.indexOf(racetorun);
        console.log(racepos);
        if (racepos === 0) {
                setPrevRace(0);
            }else{
                setPrevRace(currraceinfo.racenums[racepos - 1]);
            }
        if (racepos + 1 === currraceinfo.racenums.length){
            setNextRace(0);

        }else{
            setNextRace(currraceinfo.racenums[racepos + 1]);
        }

        
        setRaceToDisp(racepos + 1);
        setRaceToRun(racetorun);
    }
   
    const getRaceInfo = async (raceid) => {
        const raceinfo = '';//await getRacesToView(raceid);
                let currinfo = {};
                let prevrace = 0;
                let currace = 0;
                let nextrace = 0;
                currinfo = raceinfo;
                currace = raceinfo.racenums[0];
                currinfo.actualcnt = raceinfo.racenums.length;
                let scoreboardhead = [];
                for(let x = 1; x <= currinfo.racecnt; x++){
                    scoreboardhead.push('Race #' + x + ' Winner');
                }
                setScoreBoardHead(scoreboardhead);
                setCurrraceInfo(currinfo);
                if (raceinfo.racenums.length > 1){
                    nextrace = raceinfo.racenums[1];
                }
                setRaceToRun(currace);
                setPrevRace(prevrace);
                setNextRace(nextrace);
                getRacers(currace);
    }


    // RACE STUFF //
    var isRunning = false;

    const getRacers = async (currrace) => {
        setShowNext(false);
        ClearAllIntervals();
        console.log(currrace);
        if (!isRunning) {
            isRunning = true;
            let currinfo = currraceinfo;
            var raceNum = currrace;
            console.log(currinfo);
            if (JSON.stringify(currinfo) === '{}'){
                return;
            }
            try {
                
                let _speed = [];
                let _speed2 = [];
                let _speed3 = [];
                let _img = [];
                let _name = [];
                let _role = [];
                let _realPos = [];
                    let _racers = [];
                    let _posR = [];
                    let temppos = [];
                    let perfarray = [];

                            for(let i = 0; i < currinfo.racers.length; i++){
                                if (currinfo.racers[i] !== '0x0000000000000000000000000000000000000000'){
                                    const tempracer = '';//await getNFTRacer(raceNum, currinfo.racers[i]);
                                    let tmp = {};
                                    tmp.id = parseInt(tempracer.id);
                                    tmp.nftContract = tempracer.nftContract;
                                    tmp.wallet = currinfo.racers[i];
                                    tmp.perf = tempracer;
                                    _racers.push(tmp);
                                    temppos.push(i+1);
                                }
                            }
                            for (let i = 0; i < _racers.length; i++){
                          //      const randIndex = Math.floor(Math.random() * temppos.length)
                          //      const pos = temppos[randIndex];
                                _posR.push(i+1);
                          //      temppos.splice(randIndex, 1);
                            }
                            
   
                        let _ra = [];
                        for (let i = 0; i < _racers.length; i++) {
                            if (_racers[i].id !== 0 && _racers[i].id != null) {
                                _ra.push(parseInt(_racers[i].id));
                            }
                        }
                        
                        let _len = _racers.length;

                        let dd = [];
                        dd.length = _len;
                        setDistance({ d: dd });
                        _img.length = _len;
                        setImg({ url: _img });
                        var _po = [];
                        for (let i = 0; i < _len; i++) {
                            _po[i] = null;
                            let ty;

                                //ty = await getRacePerf(raceNum, _racers[i].wallet);
                                ty = _racers[i].perf;
                                let tempperf = {};
                                tempperf.id = parseInt(ty.id);
                                tempperf.steps = parseInt(ty.steps);
                            perfarray.push(tempperf);
                            let tid = parseInt(ty.id);
                            _ra[i] = tid;
                            if (_ra[i] !== 0 && _racers[i] != null) {
                                let wal = _racers[i].wallet;
                                dd[i] = 0;
                                _name[i] = await getAccountName(wal.toLowerCase());

                                if (_name[i] === "" || _name[i].toLowerCase() === wal.toLowerCase() || _name[i] === " ") {
                                    
                                    _name[i] = String(wal).substring(0, 6) + "..." + String(wal).substring(38);
                                }


                                _speed[i] = parseInt(ty.firstLeg);
                                if (_speed[i] === 0) {
                                    _speed[i] = 5;
                                }
                                _speed2[i] = parseInt(ty.secondLeg);
                                _speed3[i] = parseInt(ty.thirdLeg);

                                let id = parseInt(ty.id);
                                for (let coll = 0; coll < getcollection.length; coll++){
                                    if (ty.nftContract === getcollection[coll].address){
                                        _img[i] =  getcollection[coll].raceimage + id.toString() + ".png";
                                        break;
                                    }
                                }
                            //    _img[i] = "https://yamsdev.com/work/eor/Racers/" + id.toString() + ".png";
                            
                            }
                            
                        }

                        perfarray.sort(function (a, b) {
                            let valA = parseInt(a.steps);
                            let valB = parseInt(b.steps);
                                return valA < valB ? -1 : 1
                        })

                        for (let x = 0; x < _racers.length; x++){
                            for (let y = 0; y < perfarray.length; y++){
                                if (_racers[x].id === perfarray[y].id){
                                    _realPos[x] = y;
                                    break;
                                }
                            }
                        }

                        setRoles(_role);
                        setNums({ num: _ra });
                        setPosition({ pos: _po });
                        setImg({ url: _img });
                        setNames({ n: _name });
                        setDistance({ d: dd });
                        await new Promise(r => setTimeout(r, 3000));
                        var dist = [];
                        var doing = [];
                        for (let n = 0; n < _len; n++) {
                            dist.push(0);
                            doing.push(0);
                        }

                        var done = 0;
                        var pr = setInterval(async function () {
                            for (let j = 0; j < _len; j++) {
                                if (dist[j] >= 5000) {
                                    dist[j] = 5000;
                                    if (doing[j] === 0) {
                                        if (_realPos[j] === 0) {
                                            let _n = _name[j];
                                            setAWinner(_n);
                                            setBWinner(j);
                                            let scoreboard = [];
                                            for(let y = 0; y < raceToDisp; y++){
                                                scoreboard.push(currraceinfo.racewinners[y]);
                                            }
                                            setWinners(scoreboard)
                                        }
                                        doing[j] = 1;
                                        done += 1;
                                        _po[j] = _realPos[j] + 1;
                                    }

                                } else if (dist[j] >= 2750) {
                                    dist[j] = dist[j] + _speed3[j];

                                } else if (dist[j] >= 2250) {
                                    dist[j] = dist[j] + _speed2[j];

                                } else {
                                    dist[j] = dist[j] + _speed[j];
                                }

                            }
                            setDistance({ d: dist });
                            if (done === _len && done > 0) {
                                setPosition({ pos: _po });
                                setShowNext(true);
                                clearInterval(pr);
                            }
                        }, 20);


            } catch (err) {
                if (err.data != null) {
                    document.getElementById("demo").innerHTML = err.data.message;
                }

            }
        }
        isRunning = true;
    }


    function ShowRacers ({currraceinfo}) {
        var _text = [];
        var _nomnom = [];
        var _class = [];
        let pts = [];
        let racerlength = 0;
        if (JSON.stringify(currraceinfo) === '{}'){
            return;
        }
        for(let i = 0; i < currraceinfo.racers.length; i++){
            if (currraceinfo.racers[i] !== '0x0000000000000000000000000000000000000000'){
                racerlength+=1;
            }
        }
        //[35, 30, 28, 25, 22, 20, 18, 15, 12, 25];
        //let pts = [70, 60, 56, 50, 44, 40, 36, 30, 24, 50];
        for (let i = 0; i < racerlength; i++) {
            let rump = ((distance.d[i]*100)/5000) + '%';

            switch (position.pos[i]) {
                default:
                    _class[i] = "lane";
                    break;

                case 1:
                    _class[i] = "lane first";
                    break;
                case 2:
                    _class[i] = "lane second";
                    break;
                case 3:
                    _class[i] = "lane third";
                    break;
            }

            _text[i] = <div key={i}>
                <span className={_class[i]}>
                    {i + 1}. {names.n[i]} / #{nums.num[i]} (Pos: {position.pos[i]}{pts[position.pos[i] - 1]})
                    <br></br>
                    <div className="role">{roles[i]}</div>
                </span>
                <span style={{ marginLeft: rump }}>
                    <img src={img.url[i]} alt={""}></img><br></br>
                </span>

            </div>;
            _nomnom[i] = <>
                {i + 1}. {names.n[i]} ({position.pos[i]})<br></br>
                
            </>;


        }

        return (
            <>
                <div className="track">
                </div>
                
                {_text}

            </>
        );
    }


    const ErrorScreen = (props) => {
        switch (showNext) {
            case false:
                
                break;

            case true:
                return (
                    <div className="signUpB">
                        
                        <br></br><br></br>
                        <h1>{(nextRace === 0 ? 'Challenge Champion' : 'Race Winner')}: {aWinner }</h1>
                        <br></br>
                        <div className="winner">
                            <img src={img.url[bWinner]} alt={"winner nft"} />
                        </div>
                        <button type="button" className="btn btn-dark" style={{display:(prevRace !== 0 ? 'inline' : 'none')}} onClick={() => setRToR(prevRace)}>Run Previous Race</button>
                        <button type="button" className="btn btn-dark" style={{marginLeft:'10px', marginRight:'10px'}} onClick={() => getRacers(raceToRun)}>Rerun Race</button>
                        <button type="button" className="btn btn-dark" style={{display:(nextRace !== 0 ? 'inline' : 'none')}} onClick={() => setRToR(nextRace)}>Run Next Race</button>
                        
                    </div>
                );
                default:
                break;
        }



    }

    function ClearAllIntervals() {
        for (var i = 1; i < 99999; i++) {
            window.clearInterval(i);
        }
    }


    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    useLayoutEffect(() => {
        window.scrollTo(scrollX, scrollY);

    });


    return (
        <div className='main-appRace' id="main-app">
            <>
            <div><div className='scoreboard' style={{width:'50%', marginTop: '15%', marginLeft:'auto', marginRight:'auto'}}>Best of {currraceinfo.racecnt}</div></div>
            <div><div className='scoreboard' style={{width:'80%', marginLeft:'auto', marginRight:'auto', border:'1px solid white', display:'flex'}}>{scoreBoardHead.map(function(ind, i){return <div style={{marginLeft:'5px', marginRight:'5px', width:(Math.floor(100 / currraceinfo.racecnt) + '%'), fontWeight:'bold'}} key={'ind'+i}>{ind}</div>})}</div></div>
            <div><div className='scoreboard' style={{width:'80%', marginLeft:'auto', marginRight:'auto', border:'1px solid white', display:'flex', minHeight:'25px'}}>{winnersToShow.map(function(winr, i){return <div style={{marginLeft:'3px',width:((Math.floor(100 / currraceinfo.racecnt)) + '%'), fontSize:'.8em'}} key={'winr'+i}>{winr}</div>})}</div></div>
                <div className="windowRace">
                    Currently Viewing: Trench Challenge #{currraceinfo.negotid + ' - Race # ' + raceToDisp}  <br></br>
                    <div className="race">
                        
                        <ShowRacers currraceinfo={currraceinfo} />
                        <ErrorScreen/>
                    </div>
                    
                </div>

            </>
        </div>
    )
}